var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTableIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 5v8h12V5H2ZM0 3c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 10v3h2v-3h5V8H9V5H7v3H2v2h5Z",
  opacity: 0.4
})));
export default SvgTableIcon;